import { render, staticRenderFns } from "./new-study-completion-card.vue?vue&type=template&id=7617a6d6&"
import script from "./new-study-completion-card.vue?vue&type=script&lang=js&"
export * from "./new-study-completion-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "new-study-completion-card.vue"
export default component.exports